import authReducers from './authReducers';
import userReducers from './userReducers';
import {combineReducers} from 'redux';

export default combineReducers({
  auth: authReducers,
  user: userReducers,
});
